const state = {
	watchlistHeight: 0
}
export default state
